export function handleAlert(
  am,
  ac,
  setAlertInfo,
  dur = 3000,
  full = false,
  link = ""
) {
  setAlertInfo({
    amessage: am,
    acolor: ac,
    full: full,
    link: link,
    show: true,
  });
  if (!full) {
    setTimeout(() => {
      setAlertInfo({
        amessage: "",
        acolor: "#ffffff",
        show: false,
        full: full,
        link: link,
      });
    }, dur);
  }
}
